import { vehicles } from "@wayke-se/ecom";
import { validateTradeIn } from "../tools/data-validation";
export const getVehicleLookup = (data, callback) => {
    const isValidRequestData = validateTradeIn(data.ecomData);
    if (!isValidRequestData) {
        return callback(null);
    }
    const request = vehicles
        .newLookupRequest()
        .withRegistrationNumber(data.ecomData.registrationNumber)
        .withMileage(parseInt(data.ecomData.milage, 10))
        .withCondition(data.ecomData.condition)
        .build();
    vehicles
        .lookupVehicle(request)
        .then((response) => {
        callback(response);
    })
        .catch(() => {
        callback(null);
    });
};
